/* MT collection grid (collection template) */
  function bindCollectionDirectionFill(buttons) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    buttons.forEach(function (btn) {
      if (btn.dataset.directionFillReady === 'true') return;
      var fill = btn.querySelector('.mt-collection__btn-fill');
      if (!fill) return;
      btn.dataset.directionFillReady = 'true';

      var side = function (e) {
        var rect = btn.getBoundingClientRect();
        return e.clientX < rect.left + rect.width / 2 ? 'left' : 'right';
      };

      btn.addEventListener('pointerenter', function (e) {
        if (reduceMotion) {
          btn.classList.add('is-fill');
          return;
        }
        fill.style.transition = 'none';
        fill.style.transformOrigin = side(e);
        void fill.offsetWidth;
        fill.style.transition = 'transform 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.transform = 'scaleX(1)';
        btn.classList.add('is-fill');
      });

      btn.addEventListener('pointerleave', function (e) {
        if (reduceMotion) {
          btn.classList.remove('is-fill');
          return;
        }
        fill.style.transformOrigin = side(e);
        fill.style.transform = 'scaleX(0)';
        btn.classList.remove('is-fill');
      });
    });
  }

  if (!customElements.get('mt-collection-grid')) {
    customElements.define('mt-collection-grid', class extends HTMLElement {
      connectedCallback() {
        this.style.display = 'block';
        this.sectionId = this.dataset.sectionId;
        this.main = this.querySelector('[data-collection-main]');
        this.nav = this.querySelector('.mt-collection__nav');
        this.navPill = this.nav && this.nav.querySelector('.mt-collection__nav-pill');
        this._onClick = (event) => this.onClick(event);
        this.addEventListener('click', this._onClick);
        this._onDocClick = (event) => this.onDocumentClick(event);
        document.addEventListener('click', this._onDocClick);
        this._onPopState = () => this.syncFromUrl();
        window.addEventListener('popstate', this._onPopState);
        this.initDefaultNav();
        this.updateNavPill();
        this.initCollectionButtons();
        if (this.nav && typeof ResizeObserver !== 'undefined') {
          this._navPillRo = new ResizeObserver(() => this.updateNavPill());
          this._navPillRo.observe(this.nav);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        document.removeEventListener('click', this._onDocClick);
        window.removeEventListener('popstate', this._onPopState);
        if (this._navPillRo) this._navPillRo.disconnect();
      }

      onClick(event) {
        var sortToggle = event.target.closest('[data-collection-sort-toggle]');
        if (sortToggle && this.contains(sortToggle)) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleSortMenu(sortToggle.closest('[data-collection-sort]'));
          return;
        }

        var sortOption = event.target.closest('[data-collection-sort-option]');
        if (sortOption && this.contains(sortOption)) {
          event.preventDefault();
          this.onSortOptionClick(sortOption);
          return;
        }

        var link = event.target.closest('[data-collection-link]');
        if (!link || !this.contains(link)) return;

        var handle = link.getAttribute('data-collection-handle');
        if (!handle) return;

        event.preventDefault();
        if (link.classList.contains('is-active')) return;

        this.closeAllSortMenus();
        this.loadCollection(handle, link.href, link);
      }

      onDocumentClick(event) {
        if (event.target.closest('[data-collection-sort]')) return;
        this.closeAllSortMenus();
      }

      onSortOptionClick(option) {
        var sortBy = option.getAttribute('data-sort-value');
        if (!sortBy) return;

        var handle = this.getCurrentHandle();
        if (!handle) return;

        this.closeAllSortMenus();
        this.loadCollection(handle, '/collections/' + handle, null, true, sortBy);
      }

      toggleSortMenu(sortRoot) {
        if (!sortRoot) return;
        var willOpen = !sortRoot.classList.contains('is-open');
        this.closeAllSortMenus();
        if (!willOpen) return;

        sortRoot.classList.add('is-open');
        var toggle = sortRoot.querySelector('[data-collection-sort-toggle]');
        var menu = sortRoot.querySelector('[data-collection-sort-menu]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        if (menu) menu.hidden = false;
      }

      closeAllSortMenus() {
        this.querySelectorAll('[data-collection-sort].is-open').forEach((sortRoot) => {
          sortRoot.classList.remove('is-open');
          var toggle = sortRoot.querySelector('[data-collection-sort-toggle]');
          var menu = sortRoot.querySelector('[data-collection-sort-menu]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          if (menu) menu.hidden = true;
        });
      }

      getCurrentHandle() {
        var active = this.querySelector('[data-collection-link].is-active');
        if (active) return active.getAttribute('data-collection-handle') || '';
        return this.handleFromPath(window.location.pathname);
      }

      getNavLinks() {
        return Array.from(this.querySelectorAll('.mt-collection__nav [data-collection-link]'));
      }

      initDefaultNav() {
        var navLinks = this.getNavLinks();
        if (!navLinks.length) return;

        var pathHandle = this.handleFromPath(window.location.pathname);
        if (pathHandle && navLinks.some(function (link) {
          return link.getAttribute('data-collection-handle') === pathHandle;
        })) {
          this.setActive(pathHandle);
          return;
        }

        var first = navLinks[0];
        var firstHandle = first.getAttribute('data-collection-handle');
        if (!firstHandle) return;

        if (first.classList.contains('is-active')) return;

        this.loadCollection(firstHandle, first.href, first, false);
      }

      syncFromUrl() {
        var handle = this.handleFromPath(window.location.pathname);
        if (!handle) return;
        var sortBy = new URLSearchParams(window.location.search).get('sort_by') || '';
        this.loadCollection(handle, window.location.href, null, false, sortBy);
      }

      handleFromPath(pathname) {
        var match = pathname.match(/\/collections\/([^/?#]+)/);
        return match ? match[1] : '';
      }

      setActive(handle) {
        this.getNavLinks().forEach((link) => {
          var on = link.getAttribute('data-collection-handle') === handle;
          link.classList.toggle('is-active', on);
          link.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        this.updateNavPill();
      }

      updateNavPill() {
        if (!this.navPill || !this.nav) return;
        var active = this.nav.querySelector('[data-collection-link].is-active') || this.getNavLinks()[0];
        if (!active) return;

        var move = function () {
          var listRect = this.nav.getBoundingClientRect();
          var rect = active.getBoundingClientRect();
          this.navPill.style.height = rect.height + 'px';
          this.navPill.style.transform = 'translateY(' + (rect.top - listRect.top) + 'px)';
        }.bind(this);

        move();
        requestAnimationFrame(move);
      }

      initCollectionButtons() {
        bindCollectionDirectionFill(this.querySelectorAll('.mt-collection__btn'));
      }

      buildFetchUrl(handle, sortBy) {
        var url = '/collections/' + encodeURIComponent(handle) + '?section_id=' + this.sectionId;
        if (sortBy) url += '&sort_by=' + encodeURIComponent(sortBy);
        return url;
      }

      buildPushUrl(handle, href, sortBy) {
        var pushUrl;
        try {
          pushUrl = new URL(href || ('/collections/' + handle), window.location.origin);
        } catch (err) {
          pushUrl = new URL('/collections/' + handle, window.location.origin);
        }
        pushUrl.pathname = '/collections/' + handle;
        if (sortBy) pushUrl.searchParams.set('sort_by', sortBy);
        else pushUrl.searchParams.delete('sort_by');
        return pushUrl.pathname + pushUrl.search;
      }

      async loadCollection(handle, href, sourceLink, pushState, sortBy) {
        if (!this.sectionId || !this.main || !handle) return;
        if (pushState !== false) {
          history.pushState(
            { collectionHandle: handle, sortBy: sortBy || '' },
            '',
            this.buildPushUrl(handle, href, sortBy)
          );
        }

        this.main.classList.add('is-loading');
        this.main.setAttribute('aria-busy', 'true');

        try {
          var response = await fetch(this.buildFetchUrl(handle, sortBy));
          if (!response.ok) throw new Error('fetch failed');

          var html = await response.text();
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var nextMain = wrap.querySelector('[data-collection-main]');
          if (!nextMain) throw new Error('missing main');

          this.main.innerHTML = nextMain.innerHTML;
          this.setActive(handle);
          this.initCollectionButtons();
        } catch (err) {
          var fallback = this.buildPushUrl(handle, href, sortBy);
          if (sourceLink && href) window.location.href = href;
          else window.location.href = fallback;
        } finally {
          this.main.classList.remove('is-loading');
          this.main.removeAttribute('aria-busy');
        }
      }
    });
  }
